export const COLORS = [
  {
    number: 0,
    backgroundColor: 'FloralWhite',
    textColor: 'black',
    image: '0000.jpg',
    description: '❄️Śnieg <br>🧂 Słony  <br>Przestrzeń',
  },
  {
    number: 1,
    backgroundColor: 'Black',
    textColor: 'white',
    image: '1000.jpg',
    description:
      'Ziemia <br>Ksiądz <br>Limuzyna <br>Stoi jak zimny pomnik <br>Zwęglony',
  },
  {
    number: 2,
    backgroundColor: 'SaddleBrown',
    textColor: 'white',
    image: '2000.jpg',
    description: 'Kora <br>🍫Czekolada <br>👨🏿Murzyn ',
  },
  {
    number: 3,
    backgroundColor: 'OliveDrab',
    textColor: 'white',
    image: '3000.jpg',
    description:
      'Trawa <br>Mech <br>Relaks <br>Leży i relaksuje się<br> Upalony',
  },
  {
    number: 4,
    backgroundColor: 'Yellow',
    textColor: 'black',
    image: '4000.jpg',
    description: '☀️Słońce <br>Azjata <br>Siki<br> Młody <br>Trzęsie się',
  },
  {
    number: 5,
    backgroundColor: 'Orange',
    textColor: 'black',
    image: '5000.jpg',
    description:
      '🍊Zapach pomarańczy <br>Dojrzewa <br>Rośnie <br>Pulchnie <br>Pulsuje',
  },
  {
    number: 6,
    backgroundColor: 'Red',
    textColor: 'white',
    image: '6000.jpg',
    description:
      'Dojrzały <br>🌶️Pikantny <br>Agresywny aż leci para z nosa <br>🩸Krwawy',
  },
  {
    number: 7,
    backgroundColor: 'Pink',
    textColor: 'black',
    image: '7000.jpg',
    description: 'Hello Kitty<br>Uprawia sex',
  },
  {
    number: 8,
    backgroundColor: 'RebeccaPurple',
    textColor: 'white',
    image: '8000.jpg',
    description: 'Impreza <br>Tańczy w światłach dyskotekowych',
  },
  {
    number: 9,
    backgroundColor: '#10B1AD',
    textColor: 'black',
    image: '9000.jpg',
    description: 'Niebo. <br>🌊Woda. <br>Lata na niebie. <br>Pod woda pływa',
  },
];
